import { createHttpClient } from '@valley/shared-request';
export { createHttpClient } from '@valley/shared-request';

// src/index.ts
function createWebHttpClient(options) {
  const {
    defaultSuppressErrorToast = false,
    baseURL = "/api/v1",
    timeout = 3e4,
    withCredentials = true,
    ...createHttpClientOptions
  } = options;
  const http = createHttpClient({
    baseURL,
    timeout,
    withCredentials,
    ...createHttpClientOptions
  });
  http.interceptors.request.use((config) => {
    const requestConfig = config;
    if (requestConfig.suppressErrorToast === void 0) {
      requestConfig.suppressErrorToast = defaultSuppressErrorToast;
    }
    return requestConfig;
  });
  return http;
}

export { createWebHttpClient };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map